import Navbar from "../components/Navbar";
import { Footer, WhatsAppFloat } from "../components/Footer";

const sections = [
  {
    title: "Our Aim",
    bullets: [
      "We are transparent about what data we collect, how we use it, and with whom we may share it.",
      "We aim to be open and honest about the kind of data we gather, how we utilize it, and who we may share it with.",
      "Our goal is to comply with all applicable privacy and data protection laws and regulations."
    ]
  },
  {
    title: "Data Security",
    intro:
      "iGrade Education takes data security seriously in today's digital world. We have implemented robust security measures to protect your personal data, including:",
    bullets: [
      "Secure Socket Layer (SSL) encryption on our website to ensure secure data transmission.",
      "Access to your data is restricted to trusted and authorized employees only.",
      "Regular data backups to ensure data integrity and availability.",
      "We recommend that all users protect their login credentials and create strong, unique passwords."
    ]
  },
  {
    title: "Sharing Your Information",
    intro: "We may share your information in the following circumstances:",
    bullets: [
      "With trusted third-party service providers who assist us in delivering our services.",
      "When required by law, to comply with legal obligations, protect our rights, or ensure the safety and security of our users."
    ]
  },
  {
    title: "Types of Data We Collect",
    intro:
      "The personal data we collect depends on your location, the products and services you use, your interactions with us, and applicable regulations.",
    groups: [
      {
        heading: "Personal Identification Data",
        items: [
          "First Name and Last Name",
          "Job Title and Company Name"
        ]
      },
      {
        heading: "Demographic Information",
        items: [
          "Age",
          "Gender",
          "Date of Birth",
          "Marital Status",
          "Nationality"
        ]
      },
      {
        heading: "Contact and Educational Data",
        items: [
          "Postal Address",
          "Email Address",
          "Phone Number"
        ]
      },
      {
        heading: "Digital Identity Information",
        items: [
          "Login credentials (for registered users)",
          "Date and time of website visits",
          "Pages visited and navigation behavior",
          "Browser type and version",
          "Country of access",
          "Browser language",
          "Search terms entered",
          "Pixel tags and tracking data"
        ]
      },
      {
        heading: "Enquiries and Transactional Data",
        items: [
          "Information submitted through contact forms",
          "Billing information",
          "Recordings of conversations",
          "Customer support records"
        ]
      },
      {
        heading: "User-Generated Content",
        items: [
          "Assignments and projects",
          "Peer evaluations",
          "Survey and examination responses",
          "Forum posts",
          "Assessment-related information"
        ]
      },
      {
        heading: "Marketing Preferences",
        items: [
          "Marketing communication preferences",
          "Preferred communication channels"
        ]
      },
      {
        heading: "Behavioral Data",
        items: [
          "Browsing behavior and interests inferred from activity on our platforms"
        ]
      }
    ]
  },
  {
    title: "Communication Consent",
    intro:
      "By submitting your details on our website, you agree that iGrade Education may contact you via Email, Phone Call, SMS, and WhatsApp regarding courses, counselling, admissions, and related services. You may opt out at any time through the unsubscribe option or by contacting us."
  }
];

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />

      <div
        style={{
          background: "#f8fafc",
          minHeight: "100vh",
          padding: "120px 20px 80px"
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto"
          }}
        >
          {/* Hero */}

          <div
            style={{
              background: "linear-gradient(135deg,#071535,#0B1F4A)",
              color: "#fff",
              borderRadius: "20px",
              padding: "50px",
              marginBottom: "40px"
            }}
          >
            <span
              style={{
                background: "#F5C518",
                color: "#071535",
                padding: "6px 14px",
                borderRadius: "999px",
                fontWeight: "700",
                fontSize: "12px"
              }}
            >
              LEGAL
            </span>

            <h1
              style={{
                marginTop: "20px",
                fontSize: "42px",
                fontFamily: "Playfair Display, serif"
              }}
            >
              Privacy Policy
            </h1>

            <p
              style={{
                opacity: 0.8,
                marginTop: "10px"
              }}
            >
              Effective Date: May 2026
            </p>
          </div>

          {/* Introduction */}

          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "35px",
              marginBottom: "30px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
            }}
          >
            <p
              style={{
                lineHeight: "1.8",
                color: "#555",
                fontSize: "16px"
              }}
            >
              At <strong>iGrade Education</strong>, we are deeply committed to
              protecting your personal data and maintaining your privacy. This
              Privacy Policy describes how we collect, use, and disclose your
              personal information. Please read this policy carefully so that
              you understand how we handle your data.
            </p>
          </div>

          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "35px",
                marginBottom: "30px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
              }}
            >
              <h2
                style={{
                  color: "#071535",
                  marginBottom: "15px",
                  fontFamily: "Playfair Display, serif"
                }}
              >
                {section.title}
              </h2>

              {section.intro && (
                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8"
                  }}
                >
                  {section.intro}
                </p>
              )}

              {section.bullets && (
                <ul
                  style={{
                    marginTop: "18px",
                    paddingLeft: "22px",
                    lineHeight: "2"
                  }}
                >
                  {section.bullets.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}

              {section.groups &&
                section.groups.map((group, i) => (
                  <div key={i} style={{ marginTop: "25px" }}>
                    <h3
                      style={{
                        color: "#0B1F4A",
                        marginBottom: "10px"
                      }}
                    >
                      {group.heading}
                    </h3>

                    <ul
                      style={{
                        paddingLeft: "22px",
                        lineHeight: "2"
                      }}
                    >
                      {group.items.map((item, j) => (
                        <li key={j}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
            </div>
          ))}

          {/* Contact */}

          <div
            style={{
              background: "#071535",
              color: "#fff",
              borderRadius: "20px",
              padding: "40px",
              textAlign: "center"
            }}
          >
            <h2
              style={{
                fontFamily: "Playfair Display, serif",
                marginBottom: "20px"
              }}
            >
              Contact Us
            </h2>

            <p
              style={{
                lineHeight: "1.8",
                opacity: 0.85
              }}
            >
              If you have any questions, concerns, or requests regarding this
              Privacy Policy, please do not hesitate to contact iGrade
              Education. We are happy to assist you.
            </p>

            <p
              style={{
                marginTop: "20px",
                opacity: 0.7
              }}
            >
              By using our website and services, you acknowledge that you have
              read and understood this Privacy Policy and consent to our data
              practices described herein.
            </p>
          </div>
        </div>
      </div>

      <Footer />
      <WhatsAppFloat />
    </>
  );
}